















import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import PollingMixin from '@/Shared/PollingMixin';

const component = mixins(LocationBasedMixin, PollingMixin).extend({
    beforeMount() {
        this.awaitCompletion();
    },
    data() {
        return {
            i18nPrefix: 'payment.paypalCompletion',
            loading: false,
            error: false,
        };
    }
});

export default component;
